export default __webpack_public_path__ + "static/media/Create-documentation.b81aa1aa.md";